import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { GeolocationService } from '../../services/geolocaton/geolocation.service';
import { MapConfigService } from '../../services/map-config/map-config.service';
import union from '@turf/union';
import voronoi from '@turf/voronoi';

import { FeatureCollection, Feature } from 'geojson';
import * as L from 'leaflet';


@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss']
})

export class RegionComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('map') mapElement: ElementRef;

  private map: any;
  private subscription: Subscription[] = [];

  constructor(
    private geolocationService: GeolocationService,
    private mapConfigService: MapConfigService
  ) { }

  ngOnInit(): void {
    this.subscription.push(this.mapConfigService.layerGroupChanged.subscribe(
      (layer: L.LayerGroup) => this.unionLayerGroup(layer)
    ));
    this.mapConfigService.setActiveLayerGroup();
  }

  ngAfterViewInit(): void {
    this.subscription.push(this.geolocationService.getCurrentPosition().subscribe((pos: Position) => {
      this.mapConfigService.setCenter(pos);
      this.mapConfigService.createMap(this.mapElement);
      this.map = this.mapConfigService.getMap();
    }));
  }

  private unionLayerGroup(layerGroup: L.LayerGroup): void {
    const featureCollection = layerGroup.toGeoJSON() as FeatureCollection;
    console.log(featureCollection);
    featureCollection.features.forEach((feature: Feature) => {
      // to-do собери точки из всех полигонов, и загони их в алгоритм Вороного
    });
  }

  ngOnDestroy(): void {
    this.subscription.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

}
